import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function PrivacyPolicy() {
  useEffect(() => {
    AOS.init({ once: true, duration: 900, easing: "ease-in-out" });
  }, []);

  return (
    <>
      {/* Spacer for sticky header */}
      <div style={{ height: 0 }} />

      {/* Top Banner */}
      <section className="py-5 position-relative overflow-hidden bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto" data-aos="fade-up">
              <h1
                className="fw-bold mb-3 text-center"
                style={{
                  fontSize: "2.6rem",
                  fontFamily: "'Poppins', sans-serif",
                  color: "#2e3d9c",
                }}
              >
                Privacy <span
                  style={{
                    background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                    color: "transparent",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                  }}
                >
                  Policy
                </span>
              </h1>
              <p className="text-center text-secondary mb-4" style={{ fontSize: "1.1rem" }}>
                Updated at February 3rd, 2026
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-4 bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="card border-0 shadow-sm" style={{ borderRadius: "12px" }}>
                <div className="card-body p-4 p-md-5">
                  <div data-aos="fade-up">
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Nexen Consults ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains
                      how your personal information is collected, used, and disclosed by Nexen Consults.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      This Privacy Policy applies to our website, and its associated subdomains (collectively, our "Service")
                      alongside our application, Nexen Consults. By accessing or using our Service, you signify that you have
                      read, understood, and agree to our collection, storage, use, and disclosure of your personal information as
                      described in this Privacy Policy and our Terms of Service.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Definitions and key terms
                    </h2>
                    <p className="text-secondary mb-3" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      To help explain things as clearly as possible in this Privacy Policy, every time any of these terms are
                      referenced, are strictly defined as:
                    </p>
                    <ul className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "2" }}>
                      <li><strong>Cookie:</strong> small amount of data generated by a website and saved by your web browser. It is used to
                      identify your browser, provide analytics, remember information about you such as your language
                      preference or login information.</li>
                      <li><strong>Company:</strong> when this policy mentions "Company," "we," "us," or "our," it refers to Nexen Consults LLC,
                      (DALLAS, GA, 30132, USA.), that is responsible for your information under
                      this Privacy Policy.</li>
                      <li><strong>Country:</strong> where Nexen Consults or the owners/founders of Nexen Consults are based, in this case is
                      United States of America</li>
                      <li><strong>Customer:</strong> refers to the company, organization or person that signs up to use the Nexen Consults
                      Service to manage the relationships with your consumers or service users.</li>
                      <li><strong>Device:</strong> any internet connected device such as a phone, tablet, computer or any other device that can
                      be used to visit Nexen Consults and use the services.</li>
                      <li><strong>IP address:</strong> Every device connected to the Internet is assigned a number known as an Internet protocol
                      (IP) address. These numbers are usually assigned in geographic blocks. An IP address can often be
                      used to identify the location from which a device is connecting to the Internet.</li>
                      <li><strong>Personnel:</strong> refers to those individuals who are employed by Nexen Consults or are under contract to
                      perform a service on behalf of one of the parties.</li>
                      <li><strong>Personal Data:</strong> any information that directly, indirectly, or in connection with other information —
                      including a personal identification number — allows for the identification or identifiability of a natural
                      person.</li>
                      <li><strong>Service:</strong> refers to the service provided by Nexen Consults as described in the relative terms (if
                      available) and on this platform.</li>
                      <li><strong>External service:</strong> refers to any outside entity or platform not operated by Nexen Consults. We do not 
                      use or engage any such services for processing your data.</li>
                      <li><strong>Website:</strong> Nexen Consults's site, which can be accessed via this URL: https://nexenconsults.com/</li>
                      <li><strong>You:</strong> a person or entity that is registered with Nexen Consults to use the Services.</li>
                    </ul>
                   
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      What Information Do We Collect?
                    </h2>
                    <p className="text-secondary mb-3" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We collect information from you when you visit our website, register on our site, place an order, subscribe to
                      our newsletter, respond to a survey or fill out a form.
                    </p>
                    <ul className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "2" }}>
                      <li>Name / Username</li>
                      <li>Phone Numbers</li>
                      <li>Email Addresses</li>
                      <li>Mailing Addresses</li>
                      <li>Billing Addresses</li>
                      <li>Age</li>
                      <li>Password</li>
                    </ul>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      How does Nexen Consults collect end user information?
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Nexen Consults collects end user data necessary to provide our services to our customers. We collect 
                      information only when you directly provide it to us through our website or application. We do not obtain 
                      your data from any outside sources or platforms.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      How does Nexen Consults collect customer information?
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We collect customer information only through direct interactions with you, such as when you submit your 
                      email address, fill out a form, or contact us through our website. We do not receive or purchase your 
                      information from any outside sources.
                      </p>
                    </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Do we distribute the information we collect?
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      <strong>No.</strong> We do not sell, rent, trade, or otherwise distribute your personal or non-personal 
                      information to any outside entity, including advertisers, marketing partners, affiliated companies, or 
                      business partners. Your data is kept strictly within Nexen Consults.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      All services including hosting, database management, email processing, and customer service are managed 
                      internally by Nexen Consults. We do not engage outside service providers to handle your data.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We do not disclose any portions of our log file data, including IP addresses, for analytics or any other 
                      purpose to any outside entity.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We will not disclose your personal or non-personal information to government or law enforcement 
                      officials or private parties unless strictly required by applicable court orders, laws, rules, and regulations.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Where and when is information collected from customers and end users?
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Nexen Consults collects personal information only when you directly submit it to us through our website, 
                      forms, or direct communication. We do not obtain your information from any outside sources.
                      </p>
                    </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      How Do We Use The Information We Collect?
                    </h2>
                    <p className="text-secondary mb-3" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Any of the information we collect from you may be used in one of the following ways:
                    </p>
                    <ul className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "2" }}>
                      <li>To personalize your experience (your information helps us to better respond to your individual needs)</li>
                      <li>To improve our website (we continually strive to improve our website offerings based on the information
                      and feedback we receive from you)</li>
                      <li>To improve customer service (your information helps us to more effectively respond to your customer
                      service requests and support needs)</li>
                      <li>To process transactions</li>
                      <li>To administer a contest, promotion, survey or other site feature</li>
                      <li>To send periodic emails</li>
                    </ul>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      How Do We Use Your Email Address?
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      By submitting your email address on this website, you agree to receive emails from us. You can cancel your
                      participation in any of these email lists at any time by clicking on the opt-out link or other unsubscribe option
                      that is included in the respective email. We only send emails to people who have authorized us to contact
                      them directly. We do not send unsolicited commercial emails. We do not use your email address 
                      for advertising or audience targeting on any external platform. Email addresses submitted 
                      through the order processing page will be used for the sole purpose of sending you information and updates
                      pertaining to your order. If, however, you have provided the same email to us through another method, we
                      may use it for any of the purposes stated in this Policy. Note: If at any time you would like to unsubscribe
                      from receiving future emails, we include detailed unsubscribe instructions at the bottom of each email.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      How Long Do We Keep Your Information?
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We keep your information only so long as we need it to provide Nexen Consults services to you and fulfill the
                      purposes described in this policy. When we no longer need to use your information and there is no
                      need for us to keep it to comply with our legal or regulatory obligations, we'll either remove it from our
                      systems or depersonalize it so that we can't identify you.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      How Do We Protect Your Information?
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We implement a variety of security measures to maintain the safety of your personal information when you
                      place an order or enter, submit, or access your personal information. We offer the use of a secure server. All
                      supplied sensitive/credit information is transmitted via Secure Socket Layer (SSL) technology and then
                      encrypted into our Payment gateway providers database only to be accessible by those authorized with
                      special access rights to such systems, and are required to keep the information confidential. After a
                      transaction, your private information (credit cards, social security numbers, financials, etc.) is never kept on
                      file. We cannot, however, ensure or warrant the absolute security of any information you transmit to Nexen
                      Consults or guarantee that your information on the Service may not be accessed, disclosed, altered, or
                      destroyed by a breach of any of our physical, technical, or managerial safeguards.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Could my information be transferred to other countries?
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Nexen Consults is incorporated in United States of America. Information collected via our website or through
                      direct interactions with you may be transferred from time to time to our offices or personnel located in 
                      different regions. We do not transfer your data to any outside entities. To the fullest extent allowed by 
                      applicable law, by using any of the above, you voluntarily consent to the transfer and hosting of such 
                      information within our organization.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Is the information collected through the Nexen Consults Service secure?
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We take precautions to protect the security of your information. We have physical, electronic, and managerial
                      procedures to help safeguard, prevent unauthorized access, maintain data security, and correctly use your
                      information. However, neither people nor security systems are foolproof, including encryption systems. In
                      addition, people can commit intentional crimes, make mistakes or fail to follow policies. Therefore, while we
                      use reasonable efforts to protect your personal information, we cannot guarantee its absolute security. If
                      applicable law imposes any non-disclaimable duty to protect your personal information, you agree that
                      intentional misconduct will be the standards used to measure our compliance with that duty.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Can I update or correct my information?
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      The rights you have to request updates or corrections to the information Nexen Consults collects depend on
                      your relationship with Nexen Consults. Personnel may update or correct their information as detailed in our
                      internal company employment policies.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Customers have the right to request the restriction of certain uses and disclosures of personally identifiable
                      information as follows. You can contact us in order to (1) update or correct your personally identifiable
                      information, (2) change your preferences with respect to communications and other information you receive
                      from us, or (3) delete the personally identifiable information maintained about you on our systems (subject to
                      the following paragraph), by cancelling your account. Such updates, corrections, changes and deletions will
                      have no effect on other information that we maintain. To protect your
                      privacy and security, we may take reasonable steps (such as requesting a unique password) to verify your
                      identity before granting you profile access or making corrections. You are responsible for maintaining the
                      secrecy of your unique password and account information at all times.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      You should be aware that it is not technologically possible to remove each and every record of the
                      information you have provided to us from our system. The need to back up our systems to protect
                      information from inadvertent loss means that a copy of your information may exist in a non-erasable form
                      that will be difficult or impossible for us to locate. Promptly after receiving your request, all personal
                      information stored in databases we actively use, and other readily searchable media will be updated,
                      corrected, changed or deleted, as appropriate, as soon as and to the extent reasonably and technically
                      practicable.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      If you are an end user and wish to update, delete, or receive any information we have about you, you may do
                      so by contacting the organization of which you are a customer.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Personnel
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      If you are a Nexen Consults worker or applicant, we collect information you voluntarily provide to us. We use
                      the information collected for Human Resources purposes in order to administer benefits to workers and
                      screen applicants.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      You may contact us in order to (1) update or correct your information, (2) change your preferences with
                      respect to communications and other information you receive from us, or (3) receive a record of the
                      information we have relating to you. Such updates, corrections, changes and deletions will have no effect on
                      other information that we maintain.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Sale of Business
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      In the event of a sale, merger, or other transfer of all or substantially all of the assets of Nexen Consults 
                      or any of its Corporate Affiliates, or in the event that we discontinue our business or file a petition 
                      in bankruptcy, reorganization, or similar proceeding, we reserve the right to transfer information to a 
                      successor entity, provided that such entity agrees to adhere to the terms of this Privacy Policy.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Affiliates
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We may disclose information (including personal information) about you to our Corporate Affiliates. For
                      purposes of this Privacy Policy, "Corporate Affiliate" means any person or entity which directly or indirectly
                      controls, is controlled by or is under common control with Nexen Consults, whether by ownership or
                      otherwise. Any information relating to you that we provide to our Corporate Affiliates will be treated by those
                      Corporate Affiliates in accordance with the terms of this Privacy Policy.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Governing Law
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      This Privacy Policy is governed by the laws of United States of America without regard to its conflict of laws
                      provision. You consent to the exclusive jurisdiction of the courts in connection with any action or dispute
                      arising between the parties under or in connection with this Privacy Policy except for those individuals who
                      may have rights to make claims under Privacy Shield, or the Swiss-US framework.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      The laws of United States of America, excluding its conflicts of law rules, shall govern this Agreement and
                      your use of the website. Your use of the website may also be subject to other local, state, national, or
                      international laws.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      By using Nexen Consults or contacting us directly, you signify your acceptance of this Privacy Policy. If you
                      do not agree to this Privacy Policy, you should not engage with our website, or use our services. Continued
                      use of the website, direct engagement with us, or following the posting of changes to this Privacy Policy that
                      do not significantly affect the use or disclosure of your personal information will mean that you accept those
                      changes.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Your Consent
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We've updated our Privacy Policy to provide you with complete transparency into what is being set when you
                      visit our site and how it's being used. By using our Nexen Consults, registering an account, or making a
                      purchase, you hereby consent to our Privacy Policy and agree to its terms.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Links to Other Websites
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      This Privacy Policy applies only to the Services. The Services may contain links to other websites not
                      operated or controlled by Nexen Consults. We are not responsible for the content, accuracy, or opinions
                      expressed in such websites, and such websites are not investigated, monitored, or checked for accuracy or
                      completeness by us. Please remember that when you use a link to go from the Services to another website,
                      our Privacy Policy is no longer in effect. Your browsing and interaction on any other website, including those
                      that have a link on our platform, is subject to that website's own rules and policies. Such external websites 
                      may use their own cookies or other methods to collect information about you.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Cookies
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Nexen Consults uses "Cookies" to identify the areas of our website that you have visited. A Cookie is a small
                      piece of data stored on your computer or mobile device by your web browser. We use Cookies to enhance
                      the performance and functionality of our website but are non-essential to their use. However, without these
                      cookies, certain functionality like videos may become unavailable or you would be required to enter your
                      login details every time you visit the website as we would not be able to remember that you had logged in
                      previously. Most web browsers can be set to disable the use of Cookies. However, if you disable Cookies,
                      you may not be able to access functionality on our website correctly or at all. We never place Personally
                      Identifiable Information in Cookies.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Blocking and disabling cookies and similar technologies
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Wherever you're located you may also set your browser to block cookies and similar technologies, but this
                      action may block our essential cookies and prevent our website from functioning properly, and you may not
                      be able to fully utilize all of its features and services. You should also be aware that you may also lose some
                      saved information (e.g. saved login details, site preferences) if you block cookies on your browser. Different
                      browsers make different controls available to you. Disabling a cookie or category of cookie does not delete
                      the cookie from your browser, you will need to do this yourself from within your browser, you should visit your
                      browser's help menu for more information.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Kids' Privacy
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We do not address anyone under the age of 13. We do not knowingly collect personally identifiable
                      information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your
                      child has provided Us with Personal Data, please contact Us. If We become aware that We have collected
                      Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to
                      remove that information from Our servers.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Changes To Our Privacy Policy
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We may change our Service and policies, and we may need to make changes to this Privacy Policy so that
                      they accurately reflect our Service and policies. Unless otherwise required by law, we will notify you (for
                      example, through our Service) before we make changes to this Privacy Policy and give you an opportunity to
                      review them before they go into effect. Then, if you continue to use the Service, you will be bound by the
                      updated Privacy Policy. If you do not want to agree to this or any updated Privacy Policy, you can delete
                      your account.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      External Services
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Nexen Consults does not use any external or outside services to process, store, or handle your personal data. 
                      All data you provide to us is managed entirely within our own secure systems and infrastructure.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We do not distribute, sell, rent, or otherwise transfer your personal or non-personal information to any 
                      outside entity, organization, or service provider for any purpose. Your data stays with us and is used 
                      solely to provide you with our services.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Tracking Technologies
                    </h2>
                    <h3
                      className="fw-bold mb-3 mt-4"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.4rem",
                      }}
                    >
                      Local Storage
                    </h3>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Local Storage sometimes known as DOM storage, provides web apps with methods and protocols for
                      storing client-side data. Web storage supports persistent data storage, similar to cookies but with a
                      greatly enhanced capacity and no information stored in the HTTP request header.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Information about General Data Protection Regulation (GDPR)
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We may be collecting and using information from you if you are from the European Economic Area (EEA),
                      and in this section of our Privacy Policy we are going to explain exactly how and why is this data collected,
                      and how we maintain this data under protection from being replicated or used in the wrong way.
                    </p>
                    <h3
                      className="fw-bold mb-3 mt-4"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.4rem",
                      }}
                    >
                      What is GDPR?
                    </h3>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      GDPR is an EU-wide privacy and data protection law that regulates how EU residents' data is protected by
                      companies and enhances the control the EU residents have, over their personal data.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      The GDPR is relevant to any globally operating company and not just the EU-based businesses and EU
                      residents. Our customers' data is important irrespective of where they are located, which is why we have
                      implemented GDPR controls as our baseline standard for all our operations worldwide.
                    </p>
                    <h3
                      className="fw-bold mb-3 mt-4"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.4rem",
                      }}
                    >
                      What is personal data?
                    </h3>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Any data that relates to an identifiable or identified individual. GDPR covers a broad spectrum of information
                      that could be used on its own, or in combination with other pieces of information, to identify a person.
                      Personal data extends beyond a person's name or email address. Some examples include financial
                      information, political opinions, genetic data, biometric data, IP addresses, physical address, sexual
                      orientation, and ethnicity.
                    </p>
                    <p className="text-secondary mb-3" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      The Data Protection Principles include requirements such as:
                    </p>
                    <ul className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "2" }}>
                      <li>Personal data collected must be processed in a fair, legal, and transparent way and should only be
                      used in a way that a person would reasonably expect.</li>
                      <li>Personal data should only be collected to fulfil a specific purpose and it should only be used for that
                      purpose. Organizations must specify why they need the personal data when they collect it.</li>
                      <li>Personal data should be held no longer than necessary to fulfil its purpose.</li>
                      <li>People covered by the GDPR have the right to access their own personal data. They can also request a
                      copy of their data, and that their data be updated, deleted, restricted, or moved to another organization.</li>
                    </ul>
                    <h3
                      className="fw-bold mb-3 mt-4"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.4rem",
                      }}
                    >
                      Why is GDPR important?
                    </h3>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      GDPR adds some new requirements regarding how companies should protect individuals' personal data that
                      they collect and process. It also raises the stakes for compliance by increasing enforcement and imposing
                      greater fines for breach. Beyond these facts it's simply the right thing to do. At Nexen Consults we strongly
                      believe that your data privacy is very important and we already have solid security and privacy practices in
                      place that go beyond the requirements of this new regulation.
                    </p>
                    </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Individual Data Subject's Rights - Data Access, Portability and Deletion
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We are committed to helping our customers meet the data subject rights requirements of GDPR. Nexen
                      Consults processes or stores all personal data in fully vetted, DPA compliant vendors. We do store all
                      conversation and personal data for up to 6 years unless your account is deleted. In which case, we dispose
                      of all data in accordance with our Terms of Service and Privacy Policy, but we will not hold it longer than 60
                      days.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We are aware that if you are working with EU customers, you need to be able to provide them with the ability
                      to access, update, retrieve and remove personal data. We got you! We've been set up as self service from
                      the start and have always given you access to your data and your customers data. Our customer support
                      team is here for you to answer any questions you might have about working with the API.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      California Residents
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      The California Consumer Privacy Act (CCPA) requires us to disclose categories of Personal Information we
                      collect and how we use it, and the categories of sources from whom we collect Personal Information, which 
                      we have explained above. We do not distribute your Personal Information to any outside entity.
                    </p>
                    <p className="text-secondary mb-3" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We are also required to communicate information about rights California residents have under California law.
                      You may exercise the following rights:
                    </p>
                    <ul className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "2" }}>
                      <li><strong>Right to Know and Access.</strong> You may submit a verifiable request for information regarding the: (1)
                      categories of Personal Information we collect, use, or share; (2) purposes for which categories of
                      Personal Information are collected or used by us; (3) categories of sources from which we collect
                      Personal Information; and (4) specific pieces of Personal Information we have collected about you.</li>
                      <li><strong>Right to Equal Service.</strong> We will not discriminate against you if you exercise your privacy rights.</li>
                      <li><strong>Right to Delete.</strong> You may submit a verifiable request to close your account and we will delete Personal
                      Information about you that we have collected.</li>
                      <li><strong>Request that a business that sells a consumer's personal data, not sell the consumer's personal data.</strong></li>
                    </ul>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      If you make a request, we have one month to respond to you. If you would like to exercise any of these
                      rights, please contact us.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We do not sell the Personal Information of our users.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      For more information about these rights, please contact us.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      California Online Privacy Protection Act (CalOPPA)
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      CalOPPA requires us to disclose categories of Personal Information we collect and how we use it, and the
                      categories of sources from whom we collect Personal Information, which we have explained above. We do 
                      not distribute your Personal Information to any outside entity.
                    </p>
                    <p className="text-secondary mb-3" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      CalOPPA users have the following rights:
                    </p>
                    <ul className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "2" }}>
                      <li><strong>Right to Know and Access.</strong> You may submit a verifiable request for information regarding the: (1)
                      categories of Personal Information we collect, use, or share; (2) purposes for which categories of
                      Personal Information are collected or used by us; (3) categories of sources from which we collect
                      Personal Information; and (4) specific pieces of Personal Information we have collected about you.</li>
                      <li><strong>Right to Equal Service.</strong> We will not discriminate against you if you exercise your privacy rights.</li>
                      <li><strong>Right to Delete.</strong> You may submit a verifiable request to close your account and we will delete Personal
                      Information about you that we have collected.</li>
                      <li><strong>Right to request that a business that sells a consumer's personal data, not sell the consumer's personal
                      data.</strong></li>
                    </ul>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      If you make a request, we have one month to respond to you. If you would like to exercise any of these
                      rights, please contact us.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We do not sell the Personal Information of our users.
                    </p>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      For more information about these rights, please contact us.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      Contact Us
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Don't hesitate to contact us if you have any questions.
                    </p>
                    <div className="bg-light p-4 rounded mb-4" style={{ fontSize: "1rem", borderLeft: "4px solid #6B46C1" }}>
                      <p className="mb-1"><strong>Via Email:</strong> <a href="mailto:info@nexenconsults.com" style={{ color: "#6B46C1" }}>info@nexenconsults.com</a></p>
                      <p className="mb-1"><strong>Via Phone number:</strong> <a href="tel:+19436789878" style={{ color: "#6B46C1" }}>+1 (943) 678 9878</a></p>
                      <p className="mb-1"><strong>Via this Link:</strong> <a href="https://nexenconsults.com/contact" target="_blank" rel="noopener noreferrer" style={{ color: "#6B46C1" }}>https://nexenconsults.com/contact</a></p>
                      <p className="mb-0"><strong>Via Address:</strong> DALLAS, GA, 30132, USA</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bootstrap Icons CDN */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
      />
    </>
  );
}

